import React from 'react';
import { FormLabel } from '@mui/material';
import { useFormikContext } from 'formik';
import { useSelector } from 'react-redux';
import { useGetUserDetailsQuery } from '@/features/user/userApi';
import { BrokerGroupSelect } from '@/components/selects/BrokerGroupSelect';

export const BrokerGroupsField = ({ canEdit, isSelf = false }) => {
	const { values, setFieldValue } = useFormikContext();

	const account = useSelector((state) => state.msalAccount.account);
	const loggedInEmail = account?.username;
	const { data: currentUser } = useGetUserDetailsQuery(
		{ email: loggedInEmail },
		{ skip: !loggedInEmail || !canEdit },
	);

	const openBrokerGroupId = useSelector(
		(state) => state.dialog?.data?.brokerageProfile?.docId,
	);

	const canEditGroups = Boolean(
		canEdit && (currentUser?.isFolioAdmin || currentUser?.principleUser),
	);

	return (
		<>
			<FormLabel>Broker Group</FormLabel>
			<BrokerGroupSelect
				brokerGroupId={values.brokerGroupIds ?? []}
				onChange={(nextBrokerGroupIds = []) =>
					setFieldValue('brokerGroupIds', nextBrokerGroupIds)
				}
				multiple
				disabled={!canEditGroups}
				showAdmin={false}
				groupBy='ledger'
				isGroupFixed={(group) =>
					isSelf && String(group?.id) === String(openBrokerGroupId)
				}
				sx={{
					'& .MuiInputBase-root': {
						minHeight: 56,
						height: 56,
						alignItems: 'center',
						boxSizing: 'border-box',
						py: 0,
						flexWrap: 'nowrap',
						overflow: 'hidden',
					},
				}}
			/>
		</>
	);
};

export default BrokerGroupsField;
